
import { Component, Vue } from 'vue-property-decorator';
import Price from '@/components/price/index.vue';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import NavMenu from '@/common/navmenu.vue';
import BackTop from '@/common/backtop.vue';
import CountDown from '@/components/countdown/index.vue';
import TransferDialog from '@/components/transfer-dialog/index.vue';
import { dateTimeFormatter, readCookie } from '@/tools/tools';
import {
  orderList,
  createOrderAgain,
  orderReceived,
  orderNum,
  pageVisit,
  getDataOrder,
  getDataTradSearch,
  companyPayInfo,
  submitCompanyPay
} from '@/services/http';
import * as _ from 'lodash';

@Component({
  components: {
    Header,
    Price,
    Footer,
    CountDown,
    NavMenu,
    BackTop,
    TransferDialog
  },
  filters: {
    dateTimeFormatter(value: number) {
      return dateTimeFormatter(value);
    }
  }
})
export default class extends Vue {
  ordernumber: any = { received: 0 }

  editableTabsValue: string = '4'

  editableTabs: any[] = [
    {
      title: '全部',
      name: '4',
      content: 'Tab 1 content'
    },
    {
      title: '待付款',
      name: '0',
      content: 'Tab 2 content'
    },
    {
      title: '待发货',
      name: '1',
      content: 'Tab 2 content'
    },
    {
      title: '已发货',
      name: '2',
      content: 'Tab 2 content'
    }
    // {
    //   title: '待评价',
    //   name: '3',
    //   content: 'Tab 3 content',
    // },
  ]

  tabIndex: number = 2

  orderList: any[] = [] // 订单列表

  // page: number = 1

  status: number | string = ''

  // 当前页数
  currentpage: number = 1

  // 有无数据
  isNodata: boolean = false

  // 总条数
  totalnumber: number = 10

  pageNo: number = 1

  pageSize: number = 10

  // 关键字查询
  keyword: string = ''

  loading: boolean = false

  docmHeight: any = document.documentElement.clientHeight || document.body.clientHeight

  //  是否固定底部
  isFixed: boolean = false

  // 对公打款弹窗相关
  transferDialogVisible: boolean = false

  transferDialogStatus: number = 1

  currentOrderNo: string = ''

  currentOrderAmount: string = ''

  currentAccountName: string = ''

  currentAccountNo: string = ''

  currentBankName: string = '中国农业银行深圳尚都支行'

  currentOrderDeadline: string = ''

  currentPayerName: string = ''

  currentVoucherImage: string = ''

  activated() {
    this.status = this.$route.query.id ? +this.$route.query.id : '';
    this.editableTabsValue = this.$route.query.id ? String(this.$route.query.id) : '4';
    this.getOrderList();
    this.pageVisit();
    // document.body.addEventListener('keyup', (event) => {
    //   if (event.keyCode === 13) {
    //     this.search();
    //   }
    // });
  }

  mounted() {
    const menuHeight = (this as any).$refs.menucont.offsetHeight;
    this.isFixed = menuHeight < this.docmHeight - 200;
  }

  beforeRouteLeave(to: any, from: any, next: Function) {
    if (to.name === 'paymentSuccess') {
      next('/user');
    } else {
      next(true);
    }
  }

  private async getOrderNum() {
    const anchor = readCookie('anchor');
    const ordernumber: any = await orderNum({
      src: anchor ? (anchor.src ? anchor.src : 2) : 4,
      equip: anchor ? anchor.equip : 4,
      version: anchor ? anchor.version : '',
      companyId: 1
    });
    this.ordernumber = ordernumber.data.data;
  }

  handleClick() {
    this.pageNo = 1;
    this.pageSize = 10;
    this.currentpage = 1;
    this.status = this.selectStatus(this.editableTabsValue);
    this.orderList = [];
    this.getOrderList();
  }

  // 订单列表
  private async getOrderList() {
    const anchor = readCookie('anchor');
    await this.getOrderNum();
    this.loading = true;
    // ;(this as any).editableTabs[4].title =
    //   this.ordernumber.received > 0 ? `待评价（${this.ordernumber.received}）` : '待评价'
    const res: any = await orderList({
      pageNo: this.pageNo,
      pageSize: this.pageSize,
      status: this.status,
      keyword: this.keyword,
      src: anchor ? (anchor.src ? anchor.src : 2) : 4,
      equip: anchor ? anchor.equip : 4,
      version: anchor ? anchor.version : '',
      companyId: 1
    });
    if (res.data.code === 100) {
      res.data.data.list.forEach((item: any) => {
        item.orderDetailList.forEach((value: any) => {
          this.$set(value, 'discount_price', _.round(_.subtract(value.price, value.flashAmount), 2));
        });
      });
      this.orderList = res.data.data.list;

      this.totalnumber = res.data.data.total;
      this.isNodata = this.orderList.length === 0;
      // eslint-disable-next-line no-unused-vars
      let eventNo;
      if (this.status === 0) {
        eventNo = this.$route.query.from ? '3.1.1.1.0.0.1' : '3.2.1.2.0.0.1';
      } else if (this.status === 1) {
        eventNo = this.$route.query.from ? '3.1.1.2.0.0.1' : '3.2.1.3.0.0.1';
      } else {
        eventNo = this.$route.query.from ? '3.1.1.3.0.0.1' : '3.2.1.4.0.0.1';
      }
      if (this.status !== '' && this.status !== 3) {
        getDataOrder({
          orderNum: this.totalnumber,
          orderStatus: this.status,
          refundReason: '',
          equip: anchor ? anchor.equip : 4,
          version: anchor ? anchor.version : '',
          src: anchor ? (anchor.src ? anchor.src : 2) : 4,
          model: anchor ? anchor.model : '',
          equipVersion: anchor ? anchor.equipVersion : '',
          equipMeid: anchor ? anchor.equipMeid : '',
          eventNo,
          companyId: 1
        });
      }
    } else {
      this.$message.error(res.data.message);
    }
    this.loading = false;
  }

  private selectStatus(index: string) {
    switch (index) {
      case '4':
        return '';
      case '0':
        return 0;
      case '1':
        return 1;
      case '2':
        return 2;
      default:
        return 3;
    }
  }

  private isCompanyPay(item: any): boolean {
    return Number(item.payType) === 3 || Number(item.orderType) === 6;
  }

  private getTransferStatus(item: any): number {
    return Number(item.companyCheckStatus);
  }

  private isPendingCompanyPay(item: any): boolean {
    return this.isCompanyPay(item)
      && Number(item.orderStatus) === 0
      && this.getTransferStatus(item) === 1;
  }

  private getStatusText(item: any): string {
    if (Number(item.orderStatus) === 0 && this.isCompanyPay(item)) {
      const transferStatus = this.getTransferStatus(item);
      if (transferStatus === 1) return '待打款';
      if (transferStatus === 2) return '打款核对中';
    }
    return item.statusStr || '';
  }

  // 确认收货
  private async confirmReceived(item: any) {
    for (let i = 0; i < item.orderDetailList.length; i += 1) {
      if (item.orderDetailList[i].refundStatus === 1) {
        this.$message.warning('该订单售后中，不可确认收货!');
        return;
      }
    }
    this.$confirm('您是否确认收货?', '提示', {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(async () => {
        const res: any = await orderReceived({ orderNo: item.orderNo });
        if (res.data.code === 100) {
          const integral = res.data.data.integral > 0 ? 'bolck' : 'none';
          const growth = res.data.data.growthValue > 0 ? 'bolck' : 'none';
          this.$message.success({
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: `
            <p style="margin-bottom: 8px; color: #333; font-size: 14px;">收货成功</p>
            <span style="display: ${integral}; color: #999; font-size: 12px;">奖励积分+${res.data.data.integral}；</span>
            <span style="display: ${growth}; color: #999; font-size: 12px;">奖励成长值+${res.data.data.growthValue}</span>
          `
          });
          this.getOrderList();
        } else {
          this.$message.error(res.data.message);
        }
      })
      .catch(() => { });
  }

  // 评价
  private async comment(details: object) {
    sessionStorage.setItem('commentDetails', JSON.stringify(details));
    (this as any).$router.push({ name: 'Comment' });
  }

  // 再次购买
  private async buyAgain(item: any) {
    const anchor = readCookie('anchor');
    const res: any = await createOrderAgain({
      orderNo: item.orderNo,
      equip: anchor ? anchor.equip : 4,
      version: anchor ? anchor.version : ''
    });
    if (res.data.code === 100) {
      await getDataOrder({
        orderNum: '',
        orderStatus: item.orderStatus,
        refundReason: '',
        equip: anchor ? anchor.equip : 4,
        version: anchor ? anchor.version : '',
        src: anchor ? (anchor.src ? anchor.src : 2) : 4,
        model: anchor ? anchor.model : '',
        equipVersion: anchor ? anchor.equipVersion : '',
        equipMeid: anchor ? anchor.equipMeid : '',
        eventNo: this.$route.query.from ? '3.1.1.3.0.0.3' : '3.2.1.4.0.0.3',
        companyId: 1
      });
      this.$router.push('/card');
    } else {
      this.$message.error(res.data.message);
    }
  }

  // 去付款
  async goPay(id: string) {
    const anchor = readCookie('anchor');
    getDataOrder({
      orderNum: '',
      orderStatus: 0,
      refundReason: '',
      equip: anchor ? anchor.equip : 4,
      version: anchor ? anchor.version : '',
      src: anchor ? (anchor.src ? anchor.src : 2) : 4,
      model: anchor ? anchor.model : '',
      equipVersion: anchor ? anchor.equipVersion : '',
      equipMeid: anchor ? anchor.equipMeid : '',
      eventNo: this.$route.query.from ? '3.1.1.1.0.0.3' : '3.2.1.2.0.0.3',
      companyId: 1
    });
    this.$router.push(`/payment?id=${id}`);
  }

  goRecord() {
    this.$router.push('/exchange-list?status=0');
  }

  search() {
    this.pageSize = 10;
    this.pageNo = 1;
    this.status = '';
    this.editableTabsValue = '4';
    const anchor = readCookie('anchor');
    getDataTradSearch({
      orderNum: '',
      orderStatus: 0,
      refundReason: '',
      equip: anchor ? anchor.equip : 4,
      version: anchor ? anchor.version : '',
      src: anchor ? (anchor.src ? anchor.src : 2) : 4,
      model: anchor ? anchor.model : '',
      equipVersion: anchor ? anchor.equipVersion : '',
      equipMeid: anchor ? anchor.equipMeid : '',
      eventNo: '3.2.1.1.0.0.1',
      companyId: 1
    });
    this.getOrderList();
  }

  // 订单详情
  goOrderDetails(item: any) {
    const anchor = readCookie('anchor');
    // eslint-disable-next-line no-unused-vars
    let eventNo;
    if (this.$route.query.from) {
      // eslint-disable-next-line no-nested-ternary
      eventNo = item.orderStatus === 0
        ? '3.1.1.1.0.0.2'
        : item.orderStatus === 1
          ? '3.1.1.2.0.0.2'
          : '3.1.1.3.0.0.2';
    } else {
      // eslint-disable-next-line no-nested-ternary
      eventNo = item.orderStatus === 0
        ? '3.2.1.2.0.0.2'
        : item.orderStatus === 1
          ? '3.2.1.3.0.0.2'
          : '3.2.1.4.0.0.2';
    }
    getDataOrder({
      orderNum: '',
      orderStatus: this.status,
      refundReason: '',
      equip: anchor ? anchor.equip : 4,
      version: anchor ? anchor.version : '',
      src: anchor ? (anchor.src ? anchor.src : 2) : 4,
      model: anchor ? anchor.model : '',
      equipVersion: anchor ? anchor.equipVersion : '',
      equipMeid: anchor ? anchor.equipMeid : '',
      eventNo,
      companyId: 1
    });
    const query: any = { id: item.orderNo };
    if (this.$route.query.from) {
      query.from = 'center';
    }
    this.$router.push({ name: 'orderDetails', query });
  }

  // 查看物流
  goLogistics(item: any) {
    const packages = item.logisticsList || item.packageList;
    const packageCount = packages && packages.length ? packages.length : (item.packageCount || 1);
    this.$router.push({
      name: 'logistics',
      query: {
        orderNo: item.orderNo,
        packages: String(packageCount)
      }
    });
  }

  handleSizeChange(pageSize: number) {
    this.pageSize = pageSize;
    this.getOrderList();
    window.scrollTo(0, 0);
  }

  handleCurrentChange(pageNo: number) {
    this.pageNo = pageNo;
    this.getOrderList();
    window.scrollTo(0, 0);
  }

  // 访问页面数据埋点
  private pageVisit() {
    const anchor = readCookie('anchor');
    pageVisit({
      pageType: 6,
      equip: anchor ? anchor.equip : 4,
      version: anchor ? anchor.version : '',
      src: anchor ? (anchor.src ? anchor.src : 2) : 4,
      model: anchor ? anchor.model : '',
      equipVersion: anchor ? anchor.equipVersion : '',
      equipMeid: anchor ? anchor.equipMeid : '',
      companyId: 1
    });
  }

  // 打开对公打款弹窗
  async openTransferDialog(item: any, status: number) {
    this.currentOrderNo = item.orderNo;
    this.currentOrderAmount = item.totalAmount;
    if (item.deadline) {
      this.currentOrderDeadline = dateTimeFormatter(item.deadline);
    } else if (item.createTime) {
      this.currentOrderDeadline = dateTimeFormatter(item.createTime);
    } else {
      this.currentOrderDeadline = '';
    }
    this.transferDialogStatus = status;
    this.currentAccountName = '';
    this.currentAccountNo = '';
    this.currentBankName = '中国农业银行深圳尚都支行';
    this.currentPayerName = item.payerName || '';
    this.currentVoucherImage = item.voucherImage || '';
    const res: any = await companyPayInfo({ orderNo: item.orderNo });
    if (res.data.code === 100) {
      const [info] = res.data.data;
      this.currentOrderAmount = String(info.payAmount);
      this.currentAccountName = info.payeeAccountName;
      this.currentAccountNo = info.payeeBankNo;
      this.currentBankName = info.payeeBank;
      this.currentPayerName = info.payerName || this.currentPayerName;
      this.currentVoucherImage = info.voucherUrl || this.currentVoucherImage;
      const companyCheckStatus = Number(info.companyCheckStatus);
      if (companyCheckStatus) {
        this.transferDialogStatus = companyCheckStatus === 4 ? 1 : companyCheckStatus;
      }
    }
    this.transferDialogVisible = true;
  }

  // 提交打款凭证
  async handleTransferSubmit(payload: any) {
    let success = false;
    try {
      const res: any = await submitCompanyPay({
        orderNo: payload.orderNo,
        payerName: payload.voucherName,
        voucherUrl: payload.voucherUrl
      });
      success = res.data.code === 100;
      if (success) {
        this.currentPayerName = payload.voucherName;
        this.currentVoucherImage = payload.voucherUrl;
        this.transferDialogStatus = 2;
        this.$message.success('提交成功');
      } else {
        this.$message.error(res.data.message);
      }
    } finally {
      payload.complete(success);
    }
  }

  // 关闭对公打款弹窗
  handleTransferClose() {
    this.transferDialogVisible = false;
  }
}
